export enum StorageInboundCreateActionTypes {
  RESET_STORAGE_INBOUND_CREATE = "RESET_STORAGE_INBOUND_CREATE",
  SET_STORAGE_INBOUND_ORDER_ID = "SET_STORAGE_INBOUND_ORDER_ID",
  SET_STORAGE_INBOUND_SHIPPING_PLAN_ID = "SET_STORAGE_INBOUND_SHIPPING_PLAN_ID",
  SET_STORAGE_INBOUND_CREATE_DRAFT = "SET_STORAGE_INBOUND_CREATE_DRAFT",
  LOAD_STORAGE_INBOUND_DRAFT = "LOAD_STORAGE_INBOUND_DRAFT",
}
